<script>
  import { _ } from '@sveltia/i18n';
  import { Menu, MenuButton, MenuItemRadio } from '@sveltia/ui';

  /**
   * @import { AssetListView, EntryListView } from '$lib/types/private';
   * @import { ViewGroup } from '$lib/types/public';
   */

  /**
   * @typedef {object} Props
   * @property {{ current: EntryListView | AssetListView }} currentView Current view details.
   * @property {string} aria-controls The `aria-controls` attribute for the menu.
   * @property {string} [label] Menu button label.
   * @property {boolean} [disabled] Whether to disable the button.
   * @property {string} [noneLabel] Label to be displayed on the None item.
   * @property {ViewGroup[]} [groups] Group conditions.
   */

  /** @type {Props} */
  let {
    /* eslint-disable prefer-const */
    currentView,
    'aria-controls': ariaControls,
    label = '',
    disabled = false,
    noneLabel = '',
    groups = [],
    /* eslint-enable prefer-const */
  } = $props();
</script>

<MenuButton variant="ghost" label={label || _('group')} {disabled} popupPosition="bottom-right">
  {#snippet popup()}
    <Menu ariaLabel={_('grouping_options')} aria-controls={ariaControls}>
      <MenuItemRadio
        label={noneLabel || _('sort_keys.none')}
        checked={!currentView.current.group}
        onSelect={() => {
          currentView.current = {
            ...currentView.current,
            group: null,
          };
        }}
      />
      {#each groups as group (`${group.field}|${String(group.pattern)}`)}
        {@const { label: _label, field, pattern } = group}
        <MenuItemRadio
          label={_label}
          checked={currentView.current.group?.field === field &&
            String(currentView.current.group.pattern) === String(pattern)}
          onSelect={() => {
            currentView.current = {
              ...currentView.current,
              group: { field, pattern },
            };
          }}
        />
      {/each}
    </Menu>
  {/snippet}
</MenuButton>
